var scope_0 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/07dfe1a9d0872447cca60cf7e13c41dc.js').default;

var scope_1 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1075befa358ec3d02b74d7347a44b7b5.js').default;

var scope_2 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/18c30da552d6a75508fea52fdda36ef0.js').default;

var scope_3 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2420dacb01dc183f95f9ccbec0d0096c.js').default;

var scope_4 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3110500b488664259a1350547d8ed10d.js').default;

var scope_5 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4efb562c12ecd2b8b03f0d1be0cee6ce.js').default;

var scope_6 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/59fcd1e9804fd2a381fb22f6bfa6e5e1.js').default;

var scope_7 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5ce167e271144d0166c3433d685bcdd7.js').default;

var scope_8 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7138441011b2f794e73b92f34997ca92.js').default;

var scope_9 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8050532cdd0264d0b5f3db3d8c9a4e17.js').default;

var scope_10 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/862e6758d1db185bf83d59123594fc6f.js').default;

var scope_11 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8fba99614f857781efe8b20a5906dabb.js').default;

var scope_12 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a042151c6454aa45f041048b717e3df4.js').default;

var scope_13 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a34ff693d8a5d6a241b852f8c63fa5f5.js').default;

var scope_14 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a3673ae89c9c345b85bb9c983e44d08a.js').default;

var scope_15 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a3a46bfb7b3a0ab85725ed2d306599c8.js').default;

var scope_16 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/adda79b4307f789d07680603758290aa.js').default;

var scope_17 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bde8fb5a15229b6da20910add5a4d1f3.js').default;

var scope_18 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_19 = require('/Users/markyctian/nes-design/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f3a98fbcc54ce8b81a891fd054607792.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18, scope_19);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}